'use client'

import { ReactNode } from 'react'

interface NoLayoutTemplateProps {
  children: ReactNode
}

/**
 * No Layout Template - For pages that need no header or footer
 * Used for: Login, success confirmation, 3D product views, popup views
 */
export default function NoLayoutTemplate({ children }: NoLayoutTemplateProps) {
  return (
    <div data-layout-type="none">
      {/* No header or footer, just content */}
      <main style={{ minHeight: '100vh' }}>
        {children}
      </main>
    </div>
  )
}